import React from 'react';
import { useParams } from 'react-router-dom';
import ConnectedDynamicContentsForm from '../DynamicContentsForm';

const DynamicContentsEdit = () => {
  const { id } = useParams();

  return <ConnectedDynamicContentsForm isEdit contentId={id} />;
};

export default DynamicContentsEdit;
